module.exports = __webpack_public_path__ + "media/images/home/expand-4334c2c6baeaf9b10897a69d7f929ccb.svg";